import {Dropdown, Form, FormCheck} from "react-bootstrap";
import React, {Fragment, useState} from "react";
import {setFilter,deleteFilter} from '../../../actions/FilterActions'
import {connect} from "react-redux";
import {refreshFilters,deletePreviousFilter, setPreviousFilter,clearPrevious,clearFilters,clearBasicPreviousFilter} from "../../../actions";
import {FormGroup, Input, Label} from "reactstrap";
import {SubFilterItem} from "./index";
import OPKFilter from "./OPKFilter";

const FilterItem = ({Basic:{hospital}, Filters: {active_filter,available_filters,previous_filter},PlotData:{active_plot},clearPrevious, clearBasicPreviousFilter,clearFilters,filter,deletePreviousFilter, setFilter,deleteFilter,refreshFilters,setPreviousFilter}) => {
        const [style, setStyle] = useState({
        "overflowY": "auto",
        "height": "100px",
        "margin-left": "10px"
    });
        function sleep (time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}
    const addFilter = (clicked_filter_id) => {
            if(filter.nazwa ==='wojewodztwo'){
                clearPrevious();
                clearFilters();
                setFilter(clicked_filter_id);
                setPreviousFilter({[active_plot]: clicked_filter_id})
                 refreshFilters()}
            else {
                //Sprawdzamy czy w��czone jest brak filtr�w przy dodawniu nowego filtra je�li tak to usuwamy je. Id brak filtr�w to 2
                if(previous_filter.hasOwnProperty(active_plot) && previous_filter[active_plot].hasOwnProperty(2)){
                    deletePreviousFilter({[active_plot]: 2},"FilterItem29")
                    refreshFilters()
                }
                // Je�eli szpital posiada kategorie dla danego filtra to jest ona autmoatycznie ustawiana
                let filter_cat = available_filters.filter(x => x.id === clicked_filter_id)[0].nazwa
                if (hospital.hasOwnProperty(filter_cat)) {
                    setFilter(clicked_filter_id);
                    setPreviousFilter({[active_plot]: clicked_filter_id}, hospital[filter_cat]);
                    refreshFilters()

                }
                else{
                    setFilter(clicked_filter_id);
                    setPreviousFilter({[active_plot]: clicked_filter_id});
                    refreshFilters()

                }


            }



    };
    const removeFilter = (clicked_filter_id) => {
            // Je�eli nie zostanie �aden filtr to w��czone zostaje brak filtr�w
            if(previous_filter.hasOwnProperty(active_plot) && Object.keys(previous_filter[active_plot]).length===1){
                deleteFilter(clicked_filter_id);
                deletePreviousFilter({[active_plot]: clicked_filter_id},"filter57")
                setPreviousFilter({[active_plot]: 2})
            }
            else {
                deleteFilter(clicked_filter_id);
                deletePreviousFilter({[active_plot]: clicked_filter_id},"filter62")
            }

    };
    return (

        previous_filter.hasOwnProperty(active_plot) && previous_filter[active_plot].hasOwnProperty(filter.id)
            ? filter.pola === "opk_select"? <OPKFilter id={filter.id}/>  : <Fragment>



                    <FormGroup style={{"backgroundColor": "#f8f9fa"}} check className='wskaznikiCheckBox'>
                        <Label for={filter.nazwa} check>
                            <Input type="checkbox" name="dataPoint" id={filter.nazwa}
                                   onChange={() => removeFilter(filter.id)}
                                   checked={previous_filter[active_plot].hasOwnProperty(filter.id)}/>
                            <span className="form-check-sign"/>
                            {filter.opis != null ? filter.opis : filter.nazwa}</Label>

                    </FormGroup>


                {filter.pola !=='radio' && <Form.Group className={'p-1'} style={style}>
                    {JSON.parse(filter.pola).map(pole => <SubFilterItem subfilter={pole} filter_id={filter.id}
                                                                        key={pole[1]}/>)}

                    </Form.Group>}

            </Fragment>


            : previous_filter.hasOwnProperty(active_plot) && <Fragment  >
                <FormGroup check className='wskaznikiCheckBox'>
                    <Label for={filter.nazwa} check>
                        <Input type="checkbox" name="dataPoint" id={filter.nazwa} onChange={()=>addFilter(filter.id)}
                                checked={previous_filter[active_plot].hasOwnProperty(filter.id)}/>
                        <span className="form-check-sign"/>
                        {filter.opis != null ? filter.opis : filter.nazwa}</Label>

                </FormGroup>
            </Fragment>
    );
};

const mapStateToProps = state => ({
    Filters: state.Filters,
    PlotData: state.PlotData,
    Basic: state.Basic,

});
export default connect(mapStateToProps, {clearPrevious,refreshFilters,clearBasicPreviousFilter,clearFilters,deletePreviousFilter,setFilter,setPreviousFilter,deleteFilter})(FilterItem)